import React from 'react'

import './Comment.css';

import moment from "moment-jalaali";
moment.loadPersian();

const Comment = ({ name, userImageUrl, time, text }) => {
   return (
      <div className="comment">
         <img className="comment__user-img" src={userImageUrl} />
         <div className="comment__name-wrapper">
            <p>{name}</p>
            <small>{moment(time).fromNow()}</small>
         </div>
         <p className="comment__text">{text}</p>
      </div>
   )
}

export default Comment
